import { UpperCasePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  inject,
  input,
  signal,
  viewChild,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ScrollService } from '../../services/scroll.service';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, UpperCasePipe],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  translate = inject(TranslationService);
  scrollService = inject(ScrollService);
  private router = inject(Router);

  isOpen = signal(false);
  isScrolled = input<boolean>(false);

  private el = inject(ElementRef);

  animBottomOpen = viewChild<ElementRef>('animBottomOpen');
  animBottomClose = viewChild<ElementRef>('animBottomClose');
  animTopOpen = viewChild<ElementRef>('animTopOpen');
  animTopClose = viewChild<ElementRef>('animTopClose');

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: any) {
    const clickedInside = this.el.nativeElement.contains(target);

    if (this.isOpen() && !clickedInside) {
      this.closeMenu();
    }
  }

  closeMenu() {
    this.isOpen.set(false);
    (this.animBottomClose()?.nativeElement as any).beginElement();
    (this.animTopClose()?.nativeElement as any).beginElement();
  }

  changeLanguage() {
    const langs = this.translate.availableLanguages;
    const currentIndex = langs.indexOf(this.translate.currentLang());

    const nextIndex = (currentIndex + 1) % langs.length;
    const nextLang = langs[nextIndex];

    this.translate.setLanguage(nextLang);
  }

  toggleMenu() {
    this.isOpen.update((val) => !val);
    const isOpening = this.isOpen();

    if (isOpening) {
      (this.animBottomOpen()?.nativeElement as any).beginElement();
      (this.animTopOpen()?.nativeElement as any).beginElement();
    } else {
      (this.animBottomClose()?.nativeElement as any).beginElement();
      (this.animTopClose()?.nativeElement as any).beginElement();
    }
  }

  async scrollToSection(sectionId: string) {
    if (this.isOpen()) {
      this.closeMenu();
    }

    const isHomePage = this.router.url.split('?')[0] === '/';

    if (isHomePage) {
      this.scrollService.scrollTo(sectionId);
    } else {
      if (sectionId === 'about-me') {
        await this.router.navigate(['/quem-sou']);
      } else {
        await this.router.navigate(['/']);

        setTimeout(() => {
          this.scrollService.scrollTo(sectionId);
        }, 250);
      }
    }
  }
}
